import { defineMessages } from 'react-intl';

export default defineMessages({
    // changesMade: {
    //     id: 'agency.admin.views.messages.changesMade',
    //     defaultMessage: 'Changes made do not automatically update in our legacy Agent Portal.'
    // },
    // youMay: {
    //     id: 'agency.admin.views.messages.youMay',
    //     defaultMessage: 'You may login to the legacy Agent Portal to make changes or contact TWIA at agentservices@twia.org.'
    // }
});